<template>
  <div class="row pb-3">
    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label">Email addresses</label>
        <InputTag 
          placeholder="Enter email"
          label="name" 
          v-model="model.emails"
          add-tag-on-blur
          validate="email"
          class="vue-input-tag-custom"
        ></InputTag>
        <small class="text-muted pt-1">Enter up to 10 email addresses, separated by a comma.</small>
      </div>

      <div class="form-group mt-3 mt-sm-0" v-if="user.role.role == 'administration'">
        <DropDown 
          :placeholder="$t('user.form.access_type.placeholder')"
          :label="$t('user.form.access_type.label')"
          :name.sync="model.access_type"
          :options="access_type_options" 
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputTag from 'vue-input-tag'
import FormMixin from '@mixins/form'
import DropDown from '@components/form2/dropdown.vue'

import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    InputTag,
    DropDown
  },
  data() {
    return {
      model: {
        emails: [],
        access_type: ''
      },
      access_type_options: []
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    type() {
      let parameters = this.parameters || {}
      return parameters.type
    }
  },
  async created () {
    let type = this.parameters.type == 'users' ? 1 : this.parameters.type == 'company' ? 2 : this.parameters.type == 'individual' ? 3 : 3
    await this.$store.dispatch('role/get', {type}).then(data => {
      data.data.forEach(el => {
        this.access_type_options.push({ value: el._id, text: el.name })
      })
    })
  },
  mixins:[ FormMixin ],
  validations: {
		model:{
			emails: {
				required
      }
		}
	}
}
</script>